import { render } from "./WatchlistQuestionBuilder.vue?vue&type=template&id=8adcce7a&scoped=true"
import script from "./WatchlistQuestionBuilder.vue?vue&type=script&lang=js"
export * from "./WatchlistQuestionBuilder.vue?vue&type=script&lang=js"

import "./WatchlistQuestionBuilder.vue?vue&type=style&index=0&id=8adcce7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8adcce7a"]])

export default __exports__